<template>
    <div class="accordion-settings">

                <!-- normal & hover tabs -->
        <b-tabs pills class="button-state-tabs">

            <!-- settings normal state -->
            <b-tab title="Normal" active>

                <!-- settings group: TITLE SETTINGS -->
                <div class="settings-group-title">
                    <h6>Title content</h6>
                </div>

                <!-- title tag -->
                <div class="setting">
                    <b-form-group>

                        <label>Title tag:</label>
                        <b-form-select v-model="settingsFromWeebly.settings.titleTag" size="sm">
                            <option value="p">P</option>
                            <option value="h1">H1</option>
                            <option value="h2">H2</option>
                            <option value="h3">H3</option>
                            <option value="h4">H4</option>
                            <option value="h5">H5</option>
                            <option value="h6">H6</option>
                        </b-form-select>

                    </b-form-group>
                </div>

                <!-- font size -->
                <div class="setting">
                    <b-form-group>

                        <label for="accordion-titleFontSize-input">Font size:</label>
                        
                        <b-input-group append="px" size="sm">
                            <b-form-input id="accordion-titleFontSize-input" type="number" v-model="settingsFromWeebly.settings.fontSize" min="5" step="1" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- font family -->
                <div class="setting" v-show="!settingsFromWeebly.settings.useCustomFont">
                    <b-form-group>
                        <div style="display: flex">
                            <label for="" style="flex:1;padding-right:5px;">Font family:</label>
                            <i class="fas fa-font" style="cursor:pointer" v-b-modal="'FontLibraryClient'" v-b-tooltip.hover.top title="My Font Library"></i>
                        </div>
                        <b-form-select :options="googleFontsArray" @change="applyFont" v-model="settingsFromWeebly.settings.fontGoogleLoad" size="sm" />
                    </b-form-group>
                </div>

                <!-- custom font family -->
                <div class="setting">
                    <b-form-checkbox switch v-model="settingsFromWeebly.settings.useCustomFont" name="use-custom-font">
                        Use custom font
                    </b-form-checkbox>
                </div>
                <!-- custom font family -->
                <div class="setting" v-show="settingsFromWeebly.settings.useCustomFont" style="background: #fafbfd;padding: 10px; border: 1px solid #D8DDE5;">
                    <b-form-group>

                        <div class="setting">
                            <label for="button-customFontName">Custom font name: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Make sure to add the exact correct name', placement: 'top', boundary: 'window'}"></i></label>

                            <b-form-input id="button-customFontName" type="text" v-model="settingsFromWeebly.settings.customFontName" size="sm" />
                        </div>

                        <div class="setting">
                            <label for="button-customFontWeight">Custom font weight: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Only select a weight the weight you are loading the files for', placement: 'top', boundary: 'window'}"></i></label>

                            <b-form-select id="button-customFontWeight" v-model="settingsFromWeebly.settings.customFontWeight" size="sm">
                                <option value="100">Thin - 100</option>
                                <option value="200">Extra-LIght - 200</option>
                                <option value="300">Light - 300</option>
                                <option value="400">Regular - 400</option>
                                <option value="500">Medium - 500</option>
                                <option value="600">Semi-Bold - 600</option>
                                <option value="700">Bold - 700</option>
                                <option value="800">Extra-Bold - 800</option>
                                <option value="900">Black - 900</option>
                            </b-form-select>

                        </div>

                        <div class="setting">
                            <label for="button-customFontStyle">Custom font style: <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'Use italic if you have this option available', placement: 'top', boundary: 'window'}"></i></label>
                            <b-form-select id="button-customFontStyle" v-model="settingsFromWeebly.settings.customFontStyle" size="sm">
                                <option value="normal">Normal</option>
                                <option value="italic">Italic</option>
                            </b-form-select>
                        </div>

                    </b-form-group>
                </div>

                <!-- letter spacing DESKTOP -->
                <div class="setting">
                    <b-form-group>

                        <label for="accordiontitle-letterspacing-input">Letter spacing:</label>

                        <b-input-group append="px" size="sm">
                            <b-form-input id="accordiontitle-letterspacing-input" type="number" v-model="settingsFromWeebly.settings.letterSpacing" min="-5" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- icon: 'plus' -->
                <div class="setting">
                    <b-form-group>

                        <label>Icon type:</label>
                        <b-form-select v-model="settingsFromWeebly.settings.icon" size="sm">
                            <option value="arrow">Arrow</option>
                            <option value="plus">Plus</option>
                        </b-form-select>

                    </b-form-group>
                </div>

                <!-- icon size -->
                <div class="setting">
                    <b-form-group>

                        <label for="accordion-titleFontSize-input">Icon size:</label>
                        
                        <b-input-group append="px" size="sm">
                            <b-form-input id="accordion-iconFontSize-input" type="number" v-model="settingsFromWeebly.settings.iconSize" min="5" step="1" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- settings group: STYLES -->
                <div class="settings-group-title">
                    <h6>styles</h6>
                </div>

                <Mycolorpicker elementRef="titleColor" theColorPicker="allpickers" colorPickerName="Title color:" />

                <Mycolorpicker elementRef="iconColor" theColorPicker="allpickers" colorPickerName="Icon color:" />

                <Mycolorpicker elementRef="titleBackground" theColorPicker="allpickers" colorPickerName="Background color title:" />

                <Mycolorpicker elementRef="titleBorderColor" theColorPicker="allpickers" colorPickerName="Border color:" />

                <Mycolorpicker elementRef="contentBackground" theColorPicker="allpickers" colorPickerName="Background content area:" />

                <!-- settings group: FUNCTIONALITY -->
                <div class="settings-group-title">
                    <h6>functionality</h6>
                </div>

                <!-- activeLoad: 1, -->
                <div class="setting">
                    <b-form-group>

                        <label for="accordion-activeload-input">Active on load:</label>
                        
                        <b-input-group size="sm">
                            <b-form-input id="accordion-activeload-input" type="number" v-model="settingsFromWeebly.settings.activeLoad" min="1" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- speed: 400, -->
                <div class="setting">
                    <b-form-group>

                        <label for="accordion-speed-input">Toggle speed:</label>
                        
                        <b-input-group append="ms" size="sm">
                            <b-form-input id="accordion-speed-input" type="number" v-model="settingsFromWeebly.settings.speed" min="0" step="100" />
                        </b-input-group>

                    </b-form-group>
                </div>

                <!-- toggle: false, -->
                <div class="setting">
                    <b-form-group>

                        <label>Use as toggle: <span v-b-tooltip.hover.top title="Toggle will allow for multiple items to be opened"><i class="far fa-question-circle"></i></span></label>
                        <b-form-select v-model="settingsFromWeebly.settings.toggle" size="sm">
                            <option value="false">Accordion</option>
                            <option value="true">Toggle</option>
                        </b-form-select>

                    </b-form-group>
                </div>

            </b-tab>

            <!-- settings hover state -->
            <b-tab title="Hover">

                <!-- settings group: STYLES -->
                <div class="settings-group-title">
                    <h6>styles</h6>
                </div>

                <Mycolorpicker elementRef="titleColorHover" theColorPicker="allpickers" colorPickerName="Title color hover and active:" />

                <Mycolorpicker elementRef="iconColorHover" theColorPicker="allpickers" colorPickerName="Icon color hover and active:" />

                <Mycolorpicker elementRef="titleBackgroundHover" theColorPicker="allpickers" colorPickerName="Background color title hover and active:" />

            </b-tab>

        </b-tabs>

    </div>
</template>

<script>

import Mycolorpicker from './Mycolorpicker'
import Mycolorpickerchildblocks from './Mycolorpickerchildblocks'

export default {

    name: 'AccordionSettings',

    data() {
        return {

        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        googleFontsArray() {
            return this.$store.state.googleFontsToLoad
        },

    },

    mounted() {
        // this.lightBoxName = this.$store.state.elementIdWeebly || 'temp_name'

        // console.log('lightBoxName: ',this.lightBoxName)
    },

    components: {
        // color picker
        Mycolorpicker,
        Mycolorpickerchildblocks
    },

    methods: {
        
        // apply font in css
        applyFont() {

            console.log(event.target.value)

            let font = event.target.value

            // load google font
            this.$store.state.weeblySettings.settings.fontGoogleLoad = font

            // convert font that equals id for checking checkbox
            font = font.split(':')

            let fontNameSplit = font[0]

            // remove possible + instances from fontNameSplit string
            if(fontNameSplit.includes('+')) {
                fontNameSplit = fontNameSplit.replace(/\+/g, " ")
                this.$store.state.weeblySettings.settings.fontFamily = '"'+fontNameSplit+'"'
            } else {
                this.$store.state.weeblySettings.settings.fontFamily = fontNameSplit
            }
            
            let fontStylePart = font[1]

            if( fontStylePart.includes('i') ) {
                let fontStylePartSplit = fontStylePart.split(/(i)/g)
                this.$store.state.weeblySettings.settings.fontStyle = 'italic'
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePartSplit[0]
            } else {
                this.$store.state.weeblySettings.settings.fontWeight = fontStylePart
                this.$store.state.weeblySettings.settings.fontStyle = 'normal'
            }

        }

    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';

.trigger-link-to-copy {
    border: 1px solid @border_grey_dark;
    border-radius: .25rem;
    padding: 0.25rem 0.5rem;
    font-size: 13px;
}

.button-state-tabs .nav {
    background: #fafbfd;
    border: 1px solid #f2f3f5;
    border-radius: 0.25rem;
}
.button-state-tabs li.nav-item {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
}

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/AccordionSettings.vue